
(function(){
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine    = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const pointer = { x:-999, y:-999 };
  addEventListener('pointermove', e => { pointer.x = e.clientX; pointer.y = e.clientY; },
    { passive:true });
  if(fine && !reduced){
    const halo = document.querySelector('.halo');
    let hx = innerWidth/2, hy = innerHeight/2;
    (function loop(){
      hx += (pointer.x - hx) * 0.045;
      hy += (pointer.y - hy) * 0.045;
      halo.style.setProperty('--hx', hx + 'px');
      halo.style.setProperty('--hy', hy + 'px');
      requestAnimationFrame(loop);
    })();
  }
  const GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/\\#*<>[]{}=+';
  function scramble(el, dur){
    if(reduced) return;
    const txt = el.dataset.txt || (el.dataset.txt = el.textContent);
    if(el.dataset.busy === '1') return;
    el.dataset.busy = '1';
    const total = dur || 850;
    const t0 = performance.now();
    const guard = setTimeout(() => finish(), total + 400);
    function finish(){
      clearTimeout(guard);
      el.textContent = txt;
      el.dataset.busy = '0';
    }
    (function frame(){
      if(el.dataset.busy !== '1') return;          // ya restaurado por el guard
      const p = Math.min(1, (performance.now() - t0) / total);
      let out = '';
      for(let i = 0; i < txt.length; i++){
        const ch = txt[i];
        if(ch === ' ' || ch === '·'){ out += ch; continue; }
        if(p > (i / txt.length) * 0.75 + 0.25) out += ch;
        else out += GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      el.textContent = out;
      if(p < 1) requestAnimationFrame(frame);
      else finish();
    })();
  }
  document.addEventListener('visibilitychange', () => {
    if(document.visibilityState !== 'visible') return;
    document.querySelectorAll('[data-scramble]').forEach(el => {
      if(el.dataset.busy === '1'){ el.textContent = el.dataset.txt; el.dataset.busy = '0'; }
    });
  });
  const scrambles = [...document.querySelectorAll('[data-scramble]')];
  scrambles.forEach(el => {
    el.dataset.txt = el.textContent;
    const host = el.closest('a, li, .head, .badge, .salebar') || el;
    host.addEventListener('pointerenter', () => scramble(el, 650));
  });
  const sio = new IntersectionObserver((es, o) => {
    es.forEach(e => { if(e.isIntersecting){ scramble(e.target, 900); o.unobserve(e.target); } });
  }, { threshold:0.6 });
  scrambles.forEach(el => sio.observe(el));
  const chars = [];
  const splitEls = [...document.querySelectorAll('[data-split]')];
  splitEls.forEach(el => {
    const text = el.textContent.trim();
    el.textContent = '';
    for(const ch of text){
      const s = document.createElement('span');
      s.className = 'wordmark__char';
      s.textContent = ch;
      s.setAttribute('aria-hidden','true');
      el.appendChild(s);
      chars.push(s);
    }
  });
  function fit(el){
    const kids = el.querySelectorAll('.wordmark__char');
    if(!kids.length || !el.parentElement) return;
    const avail = el.parentElement.clientWidth;
    if(!avail) return;
    const factor = parseFloat(el.dataset.fit) || 0.8;
    const PROBE = 100;
    el.style.fontSize = PROBE + 'px';
    const natural = kids[kids.length-1].getBoundingClientRect().right
                  - kids[0].getBoundingClientRect().left;
    if(natural > 0) el.style.fontSize = (PROBE * avail / natural * factor) + 'px';
    const tag = el.parentElement.querySelector('.tagline');
    if(tag){
      const k = el.querySelectorAll('.wordmark__char');
      const span = k[k.length-1].getBoundingClientRect().right
                 - k[0].getBoundingClientRect().left;
      if(span > 0) tag.style.width = span + 'px';
    }
  }
  const fitAll = () => splitEls.forEach(fit);
  fitAll();
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  addEventListener('load', fitAll);
  if('ResizeObserver' in window){
    const seen = new WeakMap();
    const ro = new ResizeObserver(entries => {
      for(const en of entries){
        const w = Math.round(en.contentRect.width);
        if(seen.get(en.target) === w) continue;   // evita el bucle
        seen.set(en.target, w);
        const mark = en.target.querySelector('[data-split]');
        if(mark) fit(mark);
      }
    });
    splitEls.forEach(el => { if(el.parentElement) ro.observe(el.parentElement); });
  }
  let ft;
  addEventListener('resize', () => { clearTimeout(ft); ft = setTimeout(fitAll, 120); });
  if(fine && !reduced && chars.length){
    const RADIUS = 250, LIFT = 20, GROW = 0.2;
    const vis = new Set();
    const io = new IntersectionObserver(es => {
      es.forEach(e => e.isIntersecting ? vis.add(e.target) : vis.delete(e.target));
    }, { rootMargin:'120px' });
    chars.forEach(c => io.observe(c));
    (function loop(){
      vis.forEach(s => {
        const r = s.getBoundingClientRect();
        const cx = r.left + r.width/2, cy = r.top + r.height/2;
        const d = Math.hypot(pointer.x - cx, pointer.y - cy);
        const f = Math.max(0, 1 - d/RADIUS);
        const e = f*f*(3 - 2*f);
        const dir = pointer.x > cx ? -1 : 1;
        s.style.transform = `translate3d(${dir*e*7}px,${-e*LIFT}px,0) scale(${1 + e*GROW})`;
        s.classList.toggle('wordmark__char--lit', e > 0.3);
      });
      requestAnimationFrame(loop);
    })();
  }
  const STAR = '<span class="mq__s" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor">'
    + '<path d="M12 0l2.4 8.1L22.5 6l-6 5.9 6 5.9-8.1-2.1L12 24l-2.4-8.3L1.5 17.8l6-5.9-6-5.9 8.1 2.1z"/>'
    + '</svg></span>';
  document.querySelectorAll('[data-mq]').forEach(track => {
    const words = track.dataset.mq.split('|');
    const unit = '<span class="mq__item">'
      + words.map(w => `<span class="mq__w">${w}</span>`).join(STAR) + STAR + '</span>';
    track.innerHTML = unit;
    const unitW = track.firstElementChild.getBoundingClientRect().width;
    const need = Math.max(2, Math.ceil((innerWidth * 2) / Math.max(unitW,1)) + 1);
    track.innerHTML = unit.repeat(need);
    if(reduced) return;
    const loopW = track.getBoundingClientRect().width / need;
    let off = 0, dir = -1, boost = 0, lastY = scrollY;
    addEventListener('scroll', () => {
      const dy = scrollY - lastY; lastY = scrollY;
      if(dy !== 0) dir = dy > 0 ? -1 : 1;
      boost = Math.min(9, Math.abs(dy) * 0.3);
    }, { passive:true });
    (function tick(){
      boost *= 0.93;
      off += dir * (0.8 + boost);
      if(off <= -loopW) off += loopW;
      if(off >= 0)      off -= loopW;
      track.style.transform = `translate3d(${off}px,0,0)`;
      requestAnimationFrame(tick);
    })();
  });
  document.querySelectorAll('.sizes').forEach(g => {
    g.addEventListener('click', e => {
      const b = e.target.closest('.size');
      if(!b) return;
      g.querySelectorAll('.size').forEach(s => s.setAttribute('aria-pressed','false'));
      b.setAttribute('aria-pressed','true');
    });
  });
  const rio = new IntersectionObserver((es, o) => {
    es.forEach(e => { if(e.isIntersecting){ e.target.classList.add('in'); o.unobserve(e.target); } });
  }, { threshold:0.1, rootMargin:'0px 0px -8% 0px' });
  document.querySelectorAll('.reveal').forEach((el,i) => {
    el.style.transitionDelay = (i % 4) * 70 + 'ms';
    rio.observe(el);
  });
  const nav = document.getElementById('nav');
  addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', scrollY > 40);
  }, { passive:true });
  const vio = new IntersectionObserver(es => {
    es.forEach(e => {
      const v = e.target;
      if(e.isIntersecting){ if(v.preload === 'none') v.preload = 'auto'; v.play().catch(()=>{}); }
      else v.pause();
    });
  }, { threshold:0.05 });
  document.querySelectorAll('video').forEach(v => vio.observe(v));
})();
